// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VersionLeft {
  margin-left: 4%;
  height: 40px;
  border-radius: 5px;
  padding-inline: 1%;
  position: relative;
  top: 1%;
  margin-inline: 0;
  background-color: white;
  margin-left: 1px;
  margin-right: 2%;
}

::ng-deep.VersionLeft .mat-form-field-infix {
  border: 0 !important;
  height: 38px !important;
}

::ng-deep.VersionLeft .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.VersionLeft .mat-form-field-label-wrapper {
  top: -1px !important;
}

.VersionLeft_Tree ul,
.VersionLeft_Tree li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.VersionLeft_Tree li.example-tree-container {
  border-bottom: 0;
}
.VersionLeft_Tree ul {
  padding-left: 40px;
}
.VersionLeft_Tree li {
  padding-left: 40px;
  border: 1px dotted #2d0375;
  border-width: 0 0 1px 2px;
  position: relative;
  top: 0px;
  width: -moz-fit-content;
  width: fit-content;
}
.VersionLeft_Tree li.mat-tree-node,
.VersionLeft_Tree li div {
  margin: 0;
  position: relative;
}
.VersionLeft_Tree li ul {
  border-top: 1px dotted grey;
  margin-left: -40px;
  padding-left: 60px;
}
.VersionLeft_Tree .mat-nested-tree-node:last-child ul {
  border-left: 1px solid white;
  margin-left: -41px;
}
.VersionLeft_Tree .btn_mapping {
  background-color: #3a4fb7;
  color: white;
  border-radius: 12px;
  height: 21px;
  font-size: 12px;
  line-height: 1px;
}

.mapping_screen ul,
.mapping_screen li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.mapping_screen li.example-tree-container {
  border-bottom: 0;
}
.mapping_screen ul {
  padding-left: 40px;
}
.mapping_screen li {
  padding-left: 40px;
  border: 1px dotted #2d0375;
  border-width: 0 0 1px 2px;
  position: relative;
  top: 0px;
  width: -moz-fit-content;
  width: fit-content;
}
.mapping_screen li.mat-tree-node,
.mapping_screen li div {
  margin: 0;
  position: relative;
}
.mapping_screen li ul {
  border-top: 1px dotted grey;
  margin-left: -40px;
  padding-left: 60px;
}
.mapping_screen .mat-nested-tree-node:last-child ul {
  border-left: 1px solid white;
  margin-left: -41px;
}
.mapping_screen .btn_mapping {
  background-color: #3a4fb7;
  color: white;
  border-radius: 12px;
  height: 21px;
  font-size: 12px;
  line-height: 1px;
}

::ng-deep.mat-tree-node {
  display: flex;
  align-items: center;
  min-height: 27px !important;
  padding: 0;
  flex: 1;
  overflow: hidden;
  word-wrap: break-word;
}

::ng-deep.showOnlyDiff.mat-checkbox-checked.mat-accent .mat-checkbox-background {
  background-color: #3a4fb7 !important;
}

::ng-deep.showOnlyDiff .mat-checkbox-layout .mat-checkbox-label {
  font-weight: 600 !important;
  color: black;
}

.hide {
  display: none;
}

.show {
  display: block;
}

.my-code-editor {
  height: 400px;
}

/* Input Monaco: fill remaining column height so last line is not clipped by overflow */
.compare-input-column {
  width: 35%;
  float: left;
  height: 62vh;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.compare-input-toolbar {
  flex: 0 0 auto;
}

.compare-input-editor-wrap {
  flex: 1 1 0;
  min-height: 0;
  width: 99%;
  padding-top: 12px;
  overflow: hidden;
}

::ng-deep .compare-input-editor-wrap ngx-monaco-editor {
  display: block;
  height: 100%;
}

::ng-deep .compare-input-editor-wrap .editor-container {
  height: 100% !important;
}

.outerContainerClass {
  color: red;
}

.nav-item {
  border: none !important;
}

.nav-tabs .nav-link {
  border-color: #e9ecef #e9ecef #dee2e6;
}

.nav-tabs .nav-link.active {
  color: #ffffff;
  background-color: #17a2b8;
  border-color: #17a2b8 #dee2e6 #fff;
}

::ng-deep.isContent .mat-select-value {
  display: contents !important;
  max-width: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::ng-deep.td-loading-roller {
  display: none !important;
}

.show-version-overflow {
  overflow-x: auto;
  overflow-y: hidden;
}

.hide-version-overflow {
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
}

::ng-deep.matoutlinestyles.mappstatus .mat-mdc-text-field-wrapper {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  height: 24px !important;
}
::ng-deep.matoutlinestyles.mappstatus .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix {
  padding-bottom: 0px !important;
  min-height: 30px !important;
}
::ng-deep.matoutlinestyles.mappstatus .mat-mdc-text-field-wrapper .mat-mdc-select {
  bottom: 5px !important;
  position: relative !important;
}

::ng-deep.comparediff .editor-container {
  border: 1px solid #bcbcbc;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.progress_card {
  border-left: 4px solid #ffc107;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.primary_card {
  border-left: 4px solid #007bff;
}

.ignored_card {
  border-left: 4px solid rgba(128, 128, 128, 0.6901960784);
}

.inprogress_card {
  border-left: 4px solid #ff8900;
}

.border-gradient {
  border-left: 4px solid !important;
  border-image-slice: 1;
  border-block: 0;
  border-right: 0;
}

.border-gradient-redgreen {
  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);
}`, "",{"version":3,"sources":["webpack://./src/app/compare/compare.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AACA;EACE,oBAAA;EACA,uBAAA;AAEF;;AAAA;EACE,WAAA;EACA,UAAA;AAGF;;AADA;EACE,oBAAA;AAIF;;AAAE;;EAEE,gBAAA;EACA,SAAA;EACA,UAAA;AAGJ;AAAE;EACE,gBAAA;AAEJ;AACE;EACE,kBAAA;AACJ;AAEE;EACE,kBAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EAAA,kBAAA;AAAJ;AAGE;;EAEE,SAAA;EACA,kBAAA;AADJ;AAKE;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;AAHJ;AAME;EACE,4BAAA;EACA,kBAAA;AAJJ;AAOE;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AALJ;;AAgBI;;EAEE,gBAAA;EACA,SAAA;EACA,UAAA;AAbN;AAgBI;EACE,gBAAA;AAdN;AAiBI;EACE,kBAAA;AAfN;AAkBI;EACE,kBAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EAAA,kBAAA;AAhBN;AAmBI;;EAEE,SAAA;EACA,kBAAA;AAjBN;AAqBI;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;AAnBN;AAsBI;EACE,4BAAA;EACA,kBAAA;AApBN;AAuBI;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AArBN;;AAyBE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,UAAA;EACA,OAAA;EACA,gBAAA;EACA,qBAAA;AAtBJ;;AA0BE;EACE,oCAAA;AAvBJ;;AAyBE;EACE,2BAAA;EACA,YAAA;AAtBJ;;AAyBE;EACE,aAAA;AAtBJ;;AAwBE;EACE,cAAA;AArBJ;;AAwBE;EACE,aAAA;AArBJ;;AAyBA,uFAAA;AACA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAtBF;;AAyBA;EACE,cAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,cAAA;EACA,YAAA;AAtBF;;AAyBA;EACE,uBAAA;AAtBF;;AAyBA;EACE,UAAA;AAtBF;;AAyBA;EACE,uBAAA;AAtBF;;AAwBA;EACE,qCAAA;AArBF;;AAuBA;EACE,cAAA;EACA,yBAAA;EACA,kCAAA;AApBF;;AAuBA;EACE,4BAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,wBAAA;AApBF;;AAuBA;EACE,gBAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;AApBF;;AAuBA;EACE,2BAAA;EACA,8BAAA;EACA,uBAAA;AApBF;AAqBE;EACE,8BAAA;EACA,2BAAA;AAnBJ;AAqBE;EACE,sBAAA;EACA,6BAAA;AAnBJ;;AAwBE;EACA,yBAAA;AArBF;;AA0BA;EACE,8BAAA;AAvBF;;AAyBA;EACE,8BAAA;AAtBF;;AAwBA;EACE,8BAAA;AArBF;;AAuBA;EACE,8BAAA;AApBF;;AAsBA;EACE,wDAAA;AAnBF;;AAqBA;EACE,8BAAA;AAlBF;;AAoBA;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAjBF;;AAmBA;EACE,iEAAA;AAhBF","sourcesContent":[".VersionLeft{\r\n  margin-left: 4%;\r\n  height: 40px;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  position: relative;\r\n  top: 1%;\r\n  margin-inline: 0;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 2%;\r\n}\r\n::ng-deep.VersionLeft  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 38px !important;\r\n}\r\n::ng-deep.VersionLeft .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.VersionLeft .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n\r\n.VersionLeft_Tree{\r\n  ul,\r\n  li {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  li.example-tree-container {\r\n    border-bottom: 0;\r\n  }\r\n\r\n  ul {\r\n    padding-left: 40px;\r\n  }\r\n\r\n  li {\r\n    padding-left: 40px;\r\n    border: 1px dotted #2d0375;\r\n    border-width: 0 0 1px 2px;\r\n    position: relative;\r\n    top: 0px;\r\n    width: fit-content;\r\n  }\r\n\r\n  li.mat-tree-node,\r\n  li div {\r\n    margin: 0;\r\n    position: relative;\r\n    // top: 24px;\r\n  }\r\n\r\n  li ul {\r\n    border-top: 1px dotted grey;\r\n    margin-left: -40px;\r\n    padding-left: 60px;\r\n  }\r\n\r\n  .mat-nested-tree-node:last-child ul {\r\n    border-left: 1px solid white;\r\n    margin-left: -41px;\r\n  }\r\n\r\n  .btn_mapping{\r\n    background-color: #3a4fb7;\r\n    color: white;\r\n    border-radius: 12px;\r\n    height: 21px;\r\n    font-size: 12px;\r\n    line-height: 1px;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n  .mapping_screen{\r\n    ul,\r\n    li {\r\n      list-style: none;\r\n      margin: 0;\r\n      padding: 0;\r\n    }\r\n\r\n    li.example-tree-container {\r\n      border-bottom: 0;\r\n    }\r\n\r\n    ul {\r\n      padding-left: 40px;\r\n    }\r\n\r\n    li {\r\n      padding-left: 40px;\r\n      border: 1px dotted #2d0375;\r\n      border-width: 0 0 1px 2px;\r\n      position: relative;\r\n      top: 0px;\r\n      width: fit-content;\r\n    }\r\n\r\n    li.mat-tree-node,\r\n    li div {\r\n      margin: 0;\r\n      position: relative;\r\n      // top: 24px;\r\n    }\r\n\r\n    li ul {\r\n      border-top: 1px dotted grey;\r\n      margin-left: -40px;\r\n      padding-left: 60px;\r\n    }\r\n\r\n    .mat-nested-tree-node:last-child ul {\r\n      border-left: 1px solid white;\r\n      margin-left: -41px;\r\n    }\r\n\r\n    .btn_mapping{\r\n      background-color: #3a4fb7;\r\n      color: white;\r\n      border-radius: 12px;\r\n      height: 21px;\r\n      font-size: 12px;\r\n      line-height: 1px;\r\n    }\r\n  }\r\n\r\n  ::ng-deep.mat-tree-node {\r\n    display: flex;\r\n    align-items: center;\r\n    min-height: 27px !important;\r\n    padding: 0;\r\n    flex: 1;\r\n    overflow: hidden;\r\n    word-wrap: break-word;\r\n  }\r\n\r\n\r\n  ::ng-deep.showOnlyDiff.mat-checkbox-checked.mat-accent .mat-checkbox-background{\r\n    background-color: #3a4fb7 !important;\r\n  }\r\n  ::ng-deep.showOnlyDiff .mat-checkbox-layout .mat-checkbox-label{\r\n    font-weight: 600 !important;\r\n    color:black;\r\n  }\r\n\r\n  .hide{\r\n    display: none;\r\n  }\r\n  .show{\r\n    display: block;\r\n  }\r\n\r\n  .my-code-editor {\r\n    height: 400px;\r\n    // overflow-y: auto;\r\n}\r\n\r\n/* Input Monaco: fill remaining column height so last line is not clipped by overflow */\r\n.compare-input-column {\r\n  width: 35%;\r\n  float: left;\r\n  height: 62vh;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.compare-input-toolbar {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.compare-input-editor-wrap {\r\n  flex: 1 1 0;\r\n  min-height: 0;\r\n  width: 99%;\r\n  padding-top: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n::ng-deep .compare-input-editor-wrap ngx-monaco-editor {\r\n  display: block;\r\n  height: 100%;\r\n}\r\n\r\n::ng-deep .compare-input-editor-wrap .editor-container {\r\n  height: 100% !important;\r\n}\r\n\r\n.outerContainerClass{\r\n  color:red;\r\n}\r\n\r\n.nav-item{\r\n  border:none !important;\r\n}\r\n.nav-tabs .nav-link{\r\n  border-color: #e9ecef #e9ecef #dee2e6;\r\n}\r\n.nav-tabs .nav-link.active{\r\n  color: #ffffff;\r\n  background-color: #17a2b8;\r\n  border-color: #17a2b8 #dee2e6 #fff;\r\n}\r\n\r\n::ng-deep.isContent .mat-select-value {\r\n  display: contents !important;\r\n  max-width: 0;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n::ng-deep.td-loading-roller{\r\n  display: none !important;\r\n}\r\n\r\n.show-version-overflow {\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n}\r\n\r\n.hide-version-overflow {\r\n  overflow-x: hidden;\r\n  overflow-y: hidden;\r\n  display: flex;\r\n}\r\n\r\n::ng-deep.matoutlinestyles.mappstatus .mat-mdc-text-field-wrapper{\r\n  padding-top: 0px !important;\r\n  padding-bottom: 0px !important;\r\n  height: 24px !important;\r\n  .mat-mdc-form-field-infix{\r\n    padding-bottom: 0px !important;\r\n    min-height: 30px !important\r\n  }\r\n  .mat-mdc-select{\r\n    bottom: 5px !important;\r\n    position:relative !important;\r\n  }\r\n}\r\n\r\n::ng-deep.comparediff{\r\n  .editor-container{\r\n  border: 1px solid #bcbcbc;\r\n  }\r\n}\r\n\r\n// Card status border colors\r\n.active_card {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n.progress_card {\r\n  border-left: 4px solid #ffc107;\r\n}\r\n.failed_card {\r\n  border-left: 4px solid #da606c;\r\n}\r\n.primary_card {\r\n  border-left: 4px solid #007bff;\r\n}\r\n.ignored_card{\r\n  border-left: 4px solid #808080b0;\r\n}\r\n.inprogress_card{\r\n  border-left: 4px solid #ff8900;\r\n}\r\n.border-gradient {\r\n  border-left: 4px solid !important;\r\n  border-image-slice: 1;\r\n  border-block: 0;\r\n  border-right: 0;\r\n}\r\n.border-gradient-redgreen {\r\n  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
